import React, { Component } from "react";
import Modal from "react-responsive-modal";

class TextModalPreview extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <Modal
        open={this.props.isModalOpen}
        onClose={this.props.closeModal}
        classNames={{
          overlay: "textModalOverlay",
          modal: "customModal textModal",
          closeButton: "customCloseButton",
          closeIcon: "customCloseIcon",
        }}
      >
        <div className="textModalPreview">
          <h1>{this.props.textmodalData.title}</h1>
          <div className="text_Modal_img">
            <img src={this.props.textmodalData.img} />
          </div>
          {this.props.textmodalData.generalText && <p className="text_Modal_generaltext">{this.props.textmodalData.generalText}</p>}
          <ul className="text_Modal_List">
            {this.props.textmodalData.description
              ? this.props.textmodalData.description.map((item) => (
                  <div key={item.id}>
                    <li>{item.heading}</li>
                    <div dangerouslySetInnerHTML={{__html: item.details}} />
                  </div>
                ))
              : null}
          </ul>
        </div>
      </Modal>
    );
  }
}
export default TextModalPreview;



// WEBPACK FOOTER //
// ./src/components/TextModal/textModalPreview.js